import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card';

const PrivacyPolicy = () => {
  return (
    <Card className="glass-effect">
      <CardHeader>
        <CardTitle>Política de Privacidade</CardTitle>
        <CardDescription>
          Vigente a partir de 04 de novembro de 2025 &mdash; Versão 1.0
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6 text-sm sm:text-base leading-relaxed text-white/90">
          <p>
            A <strong>Confere Cartão</strong> (&quot;nós&quot;, &quot;nosso&quot;) valoriza a sua privacidade e está comprometida
            em proteger os seus dados pessoais. Esta Política de Privacidade explica como coletamos,
            usamos, armazenamos e protegemos as suas informações quando você utiliza o <strong>Sistema
            Conciliador de Cartões</strong> (&quot;Sistema&quot;), em total conformidade com a Lei Geral de
            Proteção de Dados (LGPD - Lei nº 13.709/2018).
          </p>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">1. Quais dados coletamos?</h2>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">1.1. Dados de Cadastro e Contato</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Nome completo ou Razão Social</li>
                <li>CPF ou CNPJ</li>
                <li>Endereço de e-mail</li>
                <li>Número de telefone</li>
                <li>Dados de faturamento (quando aplicável)</li>
              </ul>
            </div>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">1.2. Dados Financeiros e de Conciliação</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Arquivos de extratos de vendas (fornecidos pelo PDV/ERP)</li>
                <li>Arquivos de repasses de operadoras (ex: Cielo, Stone, iFood, Getnet, Tuna)</li>
                <li>Extratos bancários (OFX, CSV ou Excel)</li>
              </ul>
              <p className="text-sm text-white/70 italic">
                Nota: Esses dados são inseridos voluntariamente por você na plataforma para a
                finalidade exclusiva de realizar a conciliação automatizada.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">1.3. Dados de Navegação e Dispositivo (Cookies)</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Endereço de IP</li>
                <li>Informações de login e sessão ativa</li>
                <li>Tipo de navegador e dispositivo utilizado</li>
                <li>Páginas acessadas dentro do Sistema</li>
              </ul>
            </div>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">2. Para que usamos os seus dados? (Finalidade)</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Prestação do Serviço:</strong> Realizar o processamento e cruzamento de informações financeiras.</li>
              <li><strong>Autenticação e Segurança:</strong> Criar sua conta, gerenciar subcontas e validar sua identidade.</li>
              <li><strong>Comunicação:</strong> Enviar alertas do sistema, avisos de renovação, suporte técnico e atualizações.</li>
              <li><strong>Conformidade Legal:</strong> Cumprir obrigações fiscais, legais ou regulatórias aplicáveis.</li>
            </ul>
            <p>
              Nós <strong>não utilizamos</strong> seus dados financeiros para criar perfilamento de crédito, e <strong>não realizamos</strong> publicidade
              direcionada baseada no faturamento da sua empresa.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">3. Compartilhamento de Dados com Terceiros</h2>
            <p>
              A Confere Cartão <strong>não vende, não aluga e não comercializa</strong> os seus dados pessoais ou financeiros com terceiros.
              No entanto, para que o Sistema funcione corretamente, podemos compartilhar dados estritamente necessários com:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Provedores de Infraestrutura em Nuvem:</strong> Empresas responsáveis pela hospedagem do banco de dados (ex: AWS, Supabase).</li>
              <li><strong>Processadores de Pagamento:</strong> Plataformas parceiras que processam o pagamento da sua assinatura.</li>
              <li><strong>Autoridades Legais:</strong> Caso seja exigido por ordem judicial ou para cumprir uma obrigação legal.</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">4. Segurança e Retenção dos Dados</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <strong>Isolamento de Dados:</strong> As informações importadas para a conciliação são acessíveis apenas por você
                e pelas subcontas que você autorizar. Nossa equipe técnica não acessa seus extratos financeiros,
                exceto quando você solicita suporte explícito.
              </li>
              <li>
                <strong>Retenção:</strong> Seus dados serão armazenados enquanto sua conta estiver ativa.
                Caso cancele a assinatura, seus arquivos financeiros e dados pessoais serão excluídos de forma definitiva
                em até 30 dias, ressalvada a guarda de informações para cumprimento de obrigações fiscais.
              </li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">5. Os Seus Direitos (LGPD)</h2>
            <p>Em conformidade com o Artigo 18 da LGPD, você tem o direito de solicitar a qualquer momento:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>A confirmação da existência de tratamento dos seus dados;</li>
              <li>O acesso aos dados que possuímos sobre você;</li>
              <li>A correção de dados incompletos, inexatos ou desatualizados;</li>
              <li>A eliminação (exclusão) dos seus dados pessoais;</li>
              <li>A portabilidade dos dados a outro fornecedor de serviço;</li>
              <li>A revogação do consentimento para recebimento de comunicações.</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">6. Política de Cookies</h2>
            <p>
              O Sistema utiliza cookies essenciais para garantir o funcionamento técnico e a segurança da plataforma
              (como manter sua sessão logada de forma segura). Ao utilizar o Sistema, você concorda com o uso de cookies
              estritamente necessários. Não utilizamos cookies invasivos de rastreamento publicitário de terceiros.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">7. Alterações nesta Política</h2>
            <p>
              Esta Política de Privacidade pode passar por atualizações. Caso ocorram mudanças significativas,
              você será notificado por e-mail ou por um aviso destacado na tela inicial com pelo menos 30 dias de antecedência.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">8. Como Entrar em Contato</h2>
            <p>
              Se você tiver qualquer dúvida ou desejar exercer os seus direitos, entre em contato com o nosso
              Encarregado de Proteção de Dados (DPO) através do e-mail:
            </p>
            <p className="font-semibold text-blue-400 mt-2">contato@conferecartao.com.br</p>
            <p className="text-white/70">Equipe Responsável: Privacidade e Proteção de Dados - Confere Cartão</p>
          </section>
        </div>
      </CardContent>
    </Card>
  );
};

export default PrivacyPolicy;
